module.exports = __webpack_public_path__ + "static/tabs-label-length-dont-ac952ff10db5361633f07ebf756a0c87.png";